<div id="applyPageHeader">
  <div class="fs-4 ms-3 text-light">
    <app-navigate-back></app-navigate-back><span>Foster-Melliar</span>
  </div>
</div>
<div class="d-flex justify-content-center m-2">
  <h1 class="fs-2 m-2">Candidate Application Page</h1>
</div>
<div class="p-4">
  <div class="card d-flex p-0 shadow">
    <div class="card-body p-0 overflow-auto">
      <form [formGroup]="registrationForm">
        <div formGroupName="person">
          <div class="card-header mb-3">
            <div class="card-title">Personal Details</div>
          </div>
          <div class="d-flex justify-content-between">
            <mat-form-field>
              <mat-label>Title</mat-label>
              <mat-select formControlName="title" required>
                <mat-option
                  *ngFor="let title of constants.titles"
                  [value]="title.actualValue"
                >
                  {{ title.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select formControlName="gender" required>
                <mat-option
                  *ngFor="let gender of constants.genders"
                  [value]="gender.actualValue"
                >
                  {{ gender.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="d-flex justify-content-between">
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="firstName"
                required
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Middle Name/s</mat-label>
              <input matInput type="text" formControlName="middleNames" />
            </mat-form-field>
          </div>
          <div class="d-flex justify-content-between">
            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input matInput type="text" formControlName="lastName" required />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Maiden Name</mat-label>
              <input matInput type="text" formControlName="maidenName" />
            </mat-form-field>
          </div>
          <div class="w-100 d-flex justify-content-between">
            <mat-form-field>
              <mat-label>Home Language</mat-label>
              <mat-select formControlName="homeLanguage" required>
                <mat-option
                  *ngFor="let language of constants.languages"
                  [value]="language.actualValue"
                >
                  {{ language.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Nationality</mat-label>
              <mat-select formControlName="nationality" required>
                <mat-option
                  *ngFor="let nationality of constants.nationalities"
                  [value]="nationality.actualValue"
                >
                  {{ nationality.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Race</mat-label>
              <mat-select formControlName="race" required>
                <mat-option
                  *ngFor="let race of constants.races"
                  [value]="race.actualValue"
                >
                  {{ race.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <mat-form-field>
              <mat-label>ID Type</mat-label>
              <mat-select
                (selectionChange)="setIdType($event)"
                formControlName="idType"
                required
              >
                <mat-option
                  *ngFor="let IdType of constants.idTypes"
                  [value]="IdType.actualValue"
                >
                  {{ IdType.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div
              class="d-flex align-items-center justify-content-between w-100"
              *ngIf="saId"
            >
              <mat-form-field>
                <mat-label>ID Number</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="idNumber"
                  required
                />
              </mat-form-field>
              <div
                class="text-danger d-flex align-items-center"
                *ngIf="idNumber.errors?.idNotValid"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                  />
                  <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
                <div class="p-1">Invalid</div>
              </div>
            </div>
            <div class="d-flex w-100" *ngIf="passport">
              <mat-form-field>
                <mat-label>Passport Number</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="idNumber"
                  required
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>Date of Birth</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateOfBirth"
                  matInput
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center ps-3">
            <mat-checkbox
              class="m-2"
              matInput
              formControlName="disability"
              (change)="toggleDisability($event)"
              >Disability
            </mat-checkbox>
            <mat-form-field>
              <mat-label>Disability Type</mat-label>
              <input
                matInput
                type="text"
                formControlName="disabilityType"
                required
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Disability Comment</mat-label>
              <textarea
                matInput
                type="text"
                formControlName="disabilityComment"
                required
              ></textarea>
            </mat-form-field>
          </div>
          <div class="ps-3" [ngClass]="{ 'd-none': hideDisabilityFileUpload }">
            <input
              type="file"
              class="p-2"
              (change)="disabilityFileChange($event)"
              formControlName="disabilityFilePath"
            />
            <!-- <div class="p-2 text-danger" *ngIf="disabilityFilePath.invalid">
            Please provide a certificate of disability
          </div> -->
          </div>
          <div class="card-header mb-3 mt-3">
            <div class="card-title">Contact Details</div>
          </div>
          <div class="d-flex justify-content-between">
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" required />
            </mat-form-field>
            <div
              class="text-danger d-flex align-items-center"
              *ngIf="email.errors?.email"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
              <div class="p-1">Invalid</div>
            </div>
            <mat-form-field>
              <mat-label>Cellphone Number</mat-label>
              <input
                type="tel"
                matInput
                formControlName="cellNumber"
                maxlength="10"
                required
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Alt Number</mat-label>
              <input
                type="tel"
                matInput
                formControlName="altNumber"
                maxlength="10"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Whatsapp Number</mat-label>
              <input
                type="tel"
                matInput
                formControlName="whatsappNumber"
                maxlength="10"
              />
            </mat-form-field>
          </div>
          <div class="card-header mb-3 mt-3">
            <div class="card-title">
              <div class="d-flex align-items-center">
                Address Details
                <div class="btn-group dropend">
                  <div
                    id="googlePlacesButton"
                    class="d-flex align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-search ms-3 text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                      />
                    </svg>
                  </div>
                  <div
                    (click)="$event.stopPropagation()"
                    class="dropdown-menu w-400px"
                  >
                    <ul class="list-unstyled">
                      <h2 class="m-0 ps-3 pe-3">Search for an address</h2>
                      <li class="p-3 d-flex align-items-center">
                        <GooglePlacesComponent
                          class="w-100"
                          (setAddress)="getAddress($event)"
                          addressType="geocode"
                        ></GooglePlacesComponent>
                        <div
                          class="ms-2 cursor-pointer"
                          (click)="clearPlacesInput()"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-x"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                            />
                          </svg>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div formGroupName="streetAddress">
            <div class="d-flex justify-content-between">
              <mat-form-field>
                <mat-label>Address</mat-label>
                <input matInput type="text" formControlName="street" required />
              </mat-form-field>
              <mat-form-field class="w-25">
                <mat-label>Unit</mat-label>
                <input matInput type="text" formControlName="unit" />
              </mat-form-field>
              <mat-form-field class="w-25">
                <mat-label>Complex / Building</mat-label>
                <input matInput type="text" formControlName="complex" />
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-between">
              <mat-form-field>
                <mat-label>Suburb</mat-label>
                <input
                  matInput
                  type="text"
                  aria-label="suburb"
                  formControlName="suburb"
                  [matAutocomplete]="autoSuburbs"
                  required
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoSuburbs="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let suburb of filteredSuburbs | async"
                    [value]="suburb"
                  >
                    {{ suburb }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>City</mat-label>
                <input
                  matInput
                  type="text"
                  aria-label="city"
                  formControlName="city"
                  [matAutocomplete]="autoCities"
                  required
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoCities="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let city of filteredCities | async"
                    [value]="city"
                  >
                    {{ city }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Postal Code</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="postCode"
                  maxlength="4"
                  required
                />
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-between">
              <mat-form-field>
                <mat-label>Province</mat-label>
                <input
                  matInput
                  type="text"
                  aria-label="province"
                  formControlName="province"
                  [matAutocomplete]="autoProvinces"
                  required
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoProvinces="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let province of filteredProvinces | async"
                    [value]="province"
                  >
                    {{ province }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" required>
                  <mat-option
                    *ngFor="let country of constants.countries"
                    [value]="country.actualValue"
                  >
                    {{ country.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="card-header mb-3 mt-3">
            <div class="card-title">Next Of Kin Details</div>
          </div>
          <div class="d-flex justify-content-between">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="nextOfKinName"
                required
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Relation</mat-label>
              <input
                matInput
                type="text"
                formControlName="nextOfKinRelation"
                required
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Cellphone Number</mat-label>
              <input
                type="tel"
                matInput
                formControlName="nextOfKinCellNumber"
                maxlength="10"
                required
              />
            </mat-form-field>
          </div>
          <div class="card-header mb-3 mt-3">
            <div class="card-title">Upload CV <small>(Optional)</small></div>
          </div>
          <div class="ps-3">
            <input
              type="file"
              class="p-2"
              (change)="cvFileChange($event)"
              formControlName="cvFilePath"
            />
            <!-- <div class="text-danger p-2" *ngIf="cvFilePath.invalid">
                    Please provide a CV
                  </div> -->
          </div>
          <div class="d-flex justify-content-end">
            <button class="m-3" (click)="tryApply()" mat-raised-button>
              <span
                *ngIf="applying"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{ applying ? 'Applying...' : 'Apply Now' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
